import { createHttpClient } from '@adapters/HttpClient';
import { OperatorPinApiAdapter } from '@shared/adapters/OperatorPinApiAdapter';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation } from '@tanstack/react-query';

const adapter = new OperatorPinApiAdapter(createHttpClient(apiClientWH));
export const useOperatorPin = () => {
  const mutation = useMutation({ gcTime: 0, mutationFn: (pin: string) => adapter.validatePin(pin) });
  return { validatePin: mutation.mutateAsync, isValidatingPin: mutation.isPending };
};
